import { ILearning } from "./interfaces";
import { AxiosInstance } from "axios";

export function getLearningMaterialsBuilder(apiClient: AxiosInstance) {
  return async function getLearningMaterials(
    id: number
  ): Promise<ILearning.LearningMaterialByConcept[] | null> {
    try {
      const response = await apiClient.get(`/learning/api/materials/`, {
        params: {
          concept: id,
        },
      });
      return response.data.results;
    } catch {
      return null;
    }
  };
}
